module.exports = __webpack_public_path__ + "img/conditional-access-policy.679b01ae.png";